import { Box } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

type Props = {
  onCancel: () => void
  onSave: () => void
  isValid?: boolean
  cancelLabel?: string
  saveLabel?: string
}

export const SidepanelFooter = ({
  onCancel,
  onSave,
  isValid = true,
  cancelLabel = i18n.t('common.cancel'),
  saveLabel = i18n.t('common.save'),
}: Props) => {
  return (
    <Box flexDirection="row" gap="s12" justifyContent="flexEnd">
      <F0Button label={cancelLabel} variant="outline" size="md" onClick={onCancel} />
      <F0Button
        disabled={!isValid}
        label={saveLabel}
        variant="default"
        size="md"
        onClick={onSave}
      />
    </Box>
  )
}
